
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from "@/components/layout/Layout";
import NotFoundPage from '@/pages/NotFoundPage';
import { MainRoutes } from './MainRoutes';
import ThankYouPage from '@/pages/ThankYouPage';
import Index from '@/pages/Index';

export const AppRoutes = () => {
  console.log("Initializing AppRoutes - checking routes");
  
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* ETUSIVU - Handle index route directly here */}
        <Route index element={<Index />} />
        
        {/* Redirect legacy paths */}
        <Route path="tuotteet" element={<Navigate to="/lainatuotteet" replace />} />
        
        {/* Redirect legacy loan paths */}
        <Route path="asuntolaina" element={<Navigate to="/lainat/asuntolaina" replace />} />
        <Route path="autolaina" element={<Navigate to="/lainat/autolaina" replace />} />
        <Route path="venelaina" element={<Navigate to="/lainat/venelaina" replace />} />
        <Route path="yrityslaina" element={<Navigate to="/lainat/yrityslaina" replace />} />
        <Route path="lomalaina" element={<Navigate to="/lainat/lomalaina" replace />} />
        <Route path="kulutusluotto" element={<Navigate to="/lainat/kulutusluotto" replace />} />
        <Route path="yhdistelylaina" element={<Navigate to="/lainat/yhdistelylaina" replace />} />
        <Route path="pikalaina" element={<Navigate to="/lainat/pikalaina" replace />} />
        <Route path="joustoluotto" element={<Navigate to="/lainat/joustoluotto" replace />} />
        <Route path="luottokortti" element={<Navigate to="/lainat/pienlainat-luottokortit" replace />} />
        <Route path="remonttilaina" element={<Navigate to="/lainat/remonttilaina" replace />} />
        <Route path="mokkilaina" element={<Navigate to="/lainat/mokkilaina" replace />} />
        <Route path="haalaina" element={<Navigate to="/lainat/haalaina" replace />} />
        <Route path="caravanrahoitus" element={<Navigate to="/lainat/caravanrahoitus" replace />} />
        <Route path="moottoripyoralaina" element={<Navigate to="/lainat/moottoripyoralaina" replace />} />
        <Route path="pienkonelaina" element={<Navigate to="/lainat/pienkonelaina" replace />} />
        
        {/* Language redirects for legacy paths - redirect to standard short codes */}
        <Route path="english" element={<Navigate to="/en" replace />} />
        <Route path="swedish" element={<Navigate to="/sv" replace />} />
        <Route path="se" element={<Navigate to="/sv" replace />} />
        <Route path="arabic" element={<Navigate to="/ar" replace />} />
        <Route path="hebrew" element={<Navigate to="/he" replace />} />
        <Route path="english/*" element={<Navigate to="/en" replace />} />
        <Route path="swedish/*" element={<Navigate to="/sv" replace />} />
        <Route path="se/*" element={<Navigate to="/sv" replace />} />
        <Route path="arabic/*" element={<Navigate to="/ar" replace />} />
        <Route path="hebrew/*" element={<Navigate to="/he" replace />} />
        
        {/* Handle other routes through MainRoutes component - but exclude index */}
        <Route path="*" element={<MainRoutes />} />
        
        {/* NOT FOUND PAGES */}
        <Route path="404" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
